import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Table,
  Search,
  Button,
  Toast,
  Loader
} from 'monday-ui-react-core';
import { 
  Add as AddIcon,
  Update as UpdateIcon
} from 'monday-ui-react-core/icons';
import waveApi from '../../services/wave/waveApi';

const InvoiceList = ({ onCreateNew, onSync, isSyncing, lastSync, onSelectInvoice }) => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    setLoading(true);
    try {
      const response = await waveApi.getInvoices();
      setInvoices(response.data.businesses.edges[0].node.invoices.edges.map(edge => edge.node));
      setError(null);
    } catch (err) {
      console.error('Failed to load invoices:', err);
      setError('Failed to load invoices. Please try again.');
      Toast.show({
        message: 'Failed to load invoices',
        type: Toast.types.ERROR
      });
    } finally {
      setLoading(false);
    }
  };

  const filteredInvoices = invoices.filter(invoice => 
    invoice.invoiceNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    invoice.customer?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box className="invoice-list">
      <Box className="invoice-list-header">
        <Search
          placeholder="Search invoices..."
          value={searchTerm}
          onChange={setSearchTerm}
        />
        <Box className="invoice-actions">
          <Button
            leftIcon={UpdateIcon}
            onClick={onSync}
            loading={isSyncing}
            disabled={isSyncing}
          >
            {isSyncing ? 'Syncing...' : 'Sync with Wave'}
          </Button>
          <Button
            leftIcon={AddIcon}
            onClick={onCreateNew}
            kind="primary"
          >
            Create Invoice
          </Button>
        </Box>
      </Box>

      {loading ? (
        <Loader size={Loader.sizes.MEDIUM} />
      ) : error ? (
        <Box className="error-state">
          <p>{error}</p>
          <Button onClick={loadInvoices}>Retry</Button>
        </Box>
      ) : (
        <Table
          columns={[
            { title: 'Invoice #', field: 'invoiceNumber' },
            { title: 'Customer', field: 'customer.name' },
            { title: 'Amount', field: 'amount', type: 'currency' },
            { title: 'Status', field: 'status' },
            { title: 'Due Date', field: 'dueDate', type: 'date' }
          ]}
          data={filteredInvoices}
          onRowClick={(invoice) => onSelectInvoice(invoice)}
          emptyState={
            <Box className="empty-state">
              No invoices found
            </Box>
          }
        />
      )}

      {lastSync && (
        <Box className="sync-info">
          Last synced: {new Date(lastSync).toLocaleString()}
        </Box>
      )}
    </Box>
  );
};

export default InvoiceList; 